import { Injectable } from "@angular/core";
import {
  MetaModel,
  WidgetModel,
} from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { FeedbackPreviewDataService } from "common/services/data-services/admin/feedback-preview/feedback-preview-data.service";
import { FeedbackStudentPreviewDataService } from "common/services/data-services/admin/feedback-student/feedback-student-preview-data.service";
import { FeedbackStudentsPreviewModel } from "common/models/page-models/Feedback students preview/feedback-students-preview-data-model";
import { FeedbackStudentsPreviewMetaModel } from "common/models/page-models/Feedback students preview/feedback-students-preview-form-model";
import {
  SmMetaInputModel,
  SmMetaMultipleChoiceModel,
  SmMetaSelectModel,
  SmMetaTextAreaModel,
} from "common/models/utility-models/meta-model";
import { ROUTE_PATH } from "common/constants/sm-constants";
import { TokenService } from "common/services/core-services/get-token.service";

@Injectable({
  providedIn: "root",
})
export class FeedbackStudentPreviewWidgetService extends FormWidgetService<FeedbackStudentsPreviewModel> {
  constructor(
    protected ds: FeedbackStudentPreviewDataService,
    private tokenService: TokenService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new FeedbackStudentsPreviewMetaModel();
    return meta.getMetaModel();
  }

  override prepareMetaModel(
    dataModel: any,
    metaModel: FeedbackStudentsPreviewMetaModel,
    routeData: WidgetModel
  ): Promise<FeedbackStudentsPreviewMetaModel> {
    return new Promise<FeedbackStudentsPreviewMetaModel>((resolve, reject) => {
      metaModel["formTitle"] = "Feedback Form";
      const categories = dataModel.map(
        (item) => item.selected_category_text || " "
      );
      metaModel["categories"] = Array.from(new Set(categories))
        .filter((item) => item !== "undefined")
        .map((category) => ({ category }));

      const tokenDetails = this.tokenService.getDetailsFromToken(
        localStorage.getItem("token")
      );
      metaModel.redirectPath =
        tokenDetails?.["tokenData"]?.role === 2
          ? ROUTE_PATH.studentFeedbackGrid
          : ROUTE_PATH.feedbackStudentList;

      dataModel.forEach((question) => {
        const { id, question_text, question_type, options, selected_category_text } = question;

        switch (question_type) {
          case 0: // Input
            // console.log(' case 0');
            metaModel.properties[question.id] = new SmMetaInputModel(
              String(question.id),
              String(question.id),
              "input",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              200,
              1
            );
            break;

          case 1: // Single Choice
            let options: any[] = [];
            question.options.forEach((option) => {
              let opt = {
                value: option.option_text,
                id: option.id,
                field_name: option.id,
                label: option.option_text,
              };
              options = [...options, opt];
            });
            // console.log(' case 1', options);
            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id),
              String(question.id),
              "singleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              options,
              "",
              "id",
              false,
              false,
              false,
              false,
              false,
              false
            );
            break;

          case 2: // Yes/No
            let yesNoOptions: any[] = [
              { value: 1, id: `${question.id}_yes`, field_name: "Yes", label: "Yes" },
              { value: 0, id: `${question.id}_no`, field_name: "No", label: "No" },
            ];
            // console.log(' case 2', yesNoOptions);
            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id), // Use a unique identifier for yes/no options
              String(question.id), // Use the same identifier for consistency
              "singleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "number",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              yesNoOptions,
              "",
              "id",
              false,
              false,
              false,
              false,
              false,
              false
            );
            break;

          case 3: // Ratings
            // console.log(' case 3');
            metaModel.properties[question.id] = new SmMetaInputModel(
              String(question.id),
              String(question.id),
              "ratings",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              100,
              1
            ); break;

          case 4: // Dropdown
            // console.log(' case 4');
            metaModel.properties[question.id] = new SmMetaSelectModel(
              String(question.id),
              String(question.id),
              "select",
              true,
              "col-12 col-md-6 col-lg-6",
              1,
              1,
              question.question_text,
              "select",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              question.options,
              "option_text",
              "option_text"
            ); break;

          case 5: // TextArea
            metaModel.properties[question.id] = new SmMetaTextAreaModel(
              String(question.id),
              String(question.id),
              "SimpleTextarea",
              true,
              "col-12 col-md-6",
              1,
              1,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              200,
              1,
              false,
              false
            ); break;

          case 6:
            let mcqoptions: any[] = [];
            question.options.forEach((option: any) => {
              let opt = {
                value: option.option_text,
                id: option.id,
                field_name: option.id,
                label: option.option_text,
                selected: option.selected === 1 ? true : false
              };
              mcqoptions = [...mcqoptions, opt];
            });

            metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
              String(question.id),
              String(question.id),
              "multipleChoice",
              true,
              "col-12 col-md-6",
              1,
              2,
              question.question_text,
              "text",
              "",
              false,
              true,
              true,
              false,
              0,
              0,
              false,
              mcqoptions,
              'id',
              'value',
              true,
              false,
              false,
              false,
              false,
              false
            );
            break;

          default:
            console.warn(`Unknown question type: ${question_type}`);
        }

        // Set the selected category for the question
        if (metaModel.properties[id]) {
          metaModel.properties[id]["selectedCategory"] =
            selected_category_text || " ";
        }
      });

      resolve(metaModel);
    });
  }
} 